import React, { useEffect, useState } from "react";
import { api, fmtDate } from "../lib/api";
import { PageHeader, Surface, Btn, Field, Input, Select, Textarea, StatusTag } from "../components/Primitives";
import Disclaimer from "../components/Disclaimer";
import { Plus, X } from "@phosphor-icons/react";

export default function Maintenance() {
  const [list, setList] = useState([]);
  const [aircraft, setAircraft] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ aircraft_id: "", date: new Date().toISOString().substring(0, 10), description: "", severity: "minor" });

  const load = () => Promise.all([
    api.get("/maintenance").then((r) => setList(r.data)),
    api.get("/aircraft").then((r) => setAircraft(r.data)),
  ]);
  useEffect(() => { load(); }, []);

  const save = async () => {
    await api.post("/maintenance", form);
    setOpen(false); setForm({ aircraft_id: "", date: new Date().toISOString().substring(0, 10), description: "", severity: "minor" });
    load();
  };

  return (
    <div>
      <PageHeader overline="Operations" title="Squawks & maintenance"
        subtitle="Defects, limitations and grounding actions across the fleet."
        actions={<Btn data-testid="new-squawk-btn" onClick={() => setOpen(true)}><Plus size={14} className="inline mr-1.5" />New squawk</Btn>}
      />
      <div className="p-8">
        <Disclaimer variant="compact" className="mb-4" />
        <Surface>
          <table className="w-full text-sm">
            <thead className="border-b border-zinc-800 text-[10px] uppercase tracking-wider text-zinc-500 font-mono">
              <tr><th className="text-left py-3 px-4">Date</th><th className="text-left py-3 px-4">Aircraft</th><th className="text-left py-3 px-4">Reported by</th><th className="text-left py-3 px-4">Severity</th><th className="text-left py-3 px-4">Description</th></tr>
            </thead>
            <tbody data-testid="maintenance-table">
              {list.length === 0 && <tr><td colSpan={5} className="py-12 text-center text-zinc-500">No squawks logged.</td></tr>}
              {list.map((m) => {
                const ac = aircraft.find((a) => a.id === m.aircraft_id);
                return (
                  <tr key={m.id} className="border-b border-zinc-900">
                    <td className="py-2.5 px-4 font-mono">{fmtDate(m.date)}</td>
                    <td className="py-2.5 px-4 font-mono text-amber">{ac?.registration || "—"}</td>
                    <td className="py-2.5 px-4">{m.user_name}</td>
                    <td className="py-2.5 px-4"><StatusTag status={m.severity} /></td>
                    <td className="py-2.5 px-4 text-zinc-300">{m.description}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Surface>
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4" data-testid="squawk-modal">
          <Surface className="w-full max-w-lg p-8">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-medium">New squawk</h3>
              <button onClick={() => setOpen(false)}><X size={20} className="text-zinc-500" /></button>
            </div>
            <div className="space-y-4">
              <Field label="Aircraft">
                <Select value={form.aircraft_id} onChange={(e) => setForm({ ...form, aircraft_id: e.target.value })}>
                  <option value="">Select…</option>
                  {aircraft.map((a) => <option key={a.id} value={a.id}>{a.registration}</option>)}
                </Select>
              </Field>
              <Field label="Date"><Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></Field>
              <Field label="Severity">
                <Select value={form.severity} onChange={(e) => setForm({ ...form, severity: e.target.value })}>
                  <option value="minor">Minor</option><option value="limitation">Limitation</option><option value="grounding">Grounding</option>
                </Select>
              </Field>
              <Field label="Description"><Textarea rows={4} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></Field>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <Btn variant="ghost" onClick={() => setOpen(false)}>Cancel</Btn>
              <Btn onClick={save} data-testid="squawk-save-btn">Log squawk</Btn>
            </div>
          </Surface>
        </div>
      )}
    </div>
  );
}
